import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

const selectSystem = state => state.system;

const selectOptimizationStrategies = createSelector(
  selectSystem,
  ({ optimizationStrategies }) => optimizationStrategies,
);

export const selectStrategies = createSelector(
  selectOptimizationStrategies,
  ({ strategies }) => strategies,
);

export const selectActiveStrategy = createSelector(selectStrategies, strategies =>
  strategies.find(strategy => strategy.isActive),
);

export const selectFilteredStrategies = createSelector(
  getDebouncedSearchValue,
  selectStrategies,
  searchItems(strategy => [strategy.name]),
);
